export const DATA_GA_ID_KEY = 'data-ga-id';
export const DATA_GA_NAME_KEY = 'data-ga-name';

export const ATTRS_L1_CREATOR = {
    [DATA_GA_ID_KEY]: 'l1-creator',
    [DATA_GA_NAME_KEY]: 'L1 Creator',
};

export const ATTRS_ATTRIBUTE = {
    [DATA_GA_ID_KEY]: 'attribute',
    [DATA_GA_NAME_KEY]: 'Attribute',
};
